import * as React from 'react';

export default (props:any) => (
    <svg {...props} width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle className="innerCircle" cx="50" cy="50" r="25" fill="#FF8800" strokeWidth="5" />
        <circle className="pulsingCircle" cx="50" cy="50" r="50" fill="none" stroke="#FF8800" strokeWidth="10">
            <animate
                attributeType="SVG"
                attributeName="r"
                begin="0s"
                dur="2.0s"
                repeatCount="indefinite"
                from="20"
                to="50"
            />

            <animate
                attributeType="CSS"
                attributeName="stroke-width"
                begin="0s"
                dur="2.0s"
                repeatCount="indefinite"
                from="10"
                to="0"
            />

            <animate
                attributeType="CSS"
                attributeName="opacity"
                begin="0s"
                dur="2.0s"
                repeatCount="indefinite"
                from="1"
                to="0"
            />
        </circle>
    </svg>
);
